import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/index.scss'
import './assets/styles/lm.scss'

import LmRow from '@/components/LmRow';
import LmCol from '@/components/LmCol';
import LmRow1 from '@/components/LmRow1';
import LmImage from '@/components/LmImage';
import LmImage1 from '@/components/LmImage1';
import LmContainer from '@/components/LmContainer';
import LmCard from '@/components/LmCard';
import LmColumn from '@/components/LmColumn';
import LmColumn2 from '@/components/LmColumn2';
import LmColumns from '@/components/LmColumns';
import LmBanner from '@/components/LmBanner';
import LmThumbnail from '@/components/LmThumbnail';
import LmFiguare from '@/components/LmFiguare';
import LmFiguare1 from '@/components/LmFiguare1';
import LmSwatchesBlock from '@/components/LmSwatchesBlock';

Vue.config.productionTip = false

Vue.component('lm-row', LmRow)
Vue.component('lm-col', LmCol)
Vue.component('lm-row1', LmRow1)
Vue.component('lm-image', LmImage)
Vue.component('lm-image1', LmImage1)
Vue.component('lm-container', LmContainer)
Vue.component('lm-card', LmCard)
Vue.component('lm-column', LmColumn)
Vue.component('lm-column2', LmColumn2)
Vue.component('lm-columns', LmColumns)
Vue.component('lm-banner', LmBanner)
Vue.component('lm-thumbnail', LmThumbnail)
Vue.component('lm-figuare', LmFiguare)
Vue.component('lm-figuare1', LmFiguare1)
Vue.component('lm-swatches-block', LmSwatchesBlock)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
